import React, { useState, useEffect, useMemo } from "react";
import { ArrowLeft, PlusCircle, Eye, Edit, Edit2, Trash2 } from "react-feather";
import { Link } from "react-router-dom";
import Table from "core/pagination/datatable";
import TableTop from "Components/UI/TableTop";
import { useTableSearch } from "core/Operations/useTableSearch";
import { useForm, FormProvider, useFormContext } from "react-hook-form";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { dieselUsageValidationSchema } from "core/Operations/ValidationSchema/MasterValidationSchema";
import { yupResolver } from "@hookform/resolvers/yup";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import {
  useDeleteDieselUsageMutation,
  useDieselUsageCategoriesQuery,
  useInsertDieselUsageMutation,
  useUpdateDieselUsageMutation,
} from "AppQuries/master/DieselUsage/dieselusage";
import { toast } from "core/Operations/toast";
import { BackIcon } from "Components/UI/Icon/Icons";
import { numberToPointNumber } from "MainPages/Utils/decimal.utils";
import DieselUsageModal from "Components/Modal/master/DieselUsageModal";

const DieselUsage = () => {
  const userData = useSelector(loggedInUser);
  const [showActiveOnly, setShowActiveOnly] = useState(true);
  const [isMount, setIsMount] = useState(false);
  const { watch, setValue } = useFormContext();
  // const {
  //   data,
  //   isLoading,
  //   isError,
  //   error,
  //   refetch: GetItems,
  // } = useDieselUsageCategoriesQuery(
  //   {
  //     companyCode: userData?.companyCode,
  //     isTrue: showActiveOnly,
  //   },
  //   {
  //     enabled: userData?.companyCode,
  //   }
  // );
  const methods = useForm({
    resolver: yupResolver(dieselUsageValidationSchema),
  });
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const { mutateAsync: insertDieselUsage, isPending: isAdding } =
    useInsertDieselUsageMutation();
  const { mutateAsync: updateDieselUsage, isPending: isUpdating } =
    useUpdateDieselUsageMutation();

  const { mutateAsync: deleteDieselUsage, isPending: isDeleting } =
    useDeleteDieselUsageMutation();
  const [selectedItem, setSelectedItem] = useState(null);

  const [show, setShow] = useState(false);
  const handleClose = () => {
    methods.reset();
    setShow(false);
  };
  const handleShow = () => setShow(true);

  const handleAddClick = () => {
    setSelectedItem(null);
    methods.reset({
      companyCode: userData.companyCode,
      dieselID: 0,
      invoiceNumber: "",
      invoiceDate: "",
      usageLitres: numberToPointNumber(0),
      amountInclGST: numberToPointNumber(0),
      vehicleNumber: "",
      isActive: true,
      createUser: userData.userName,
      createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const handleEditClick = (item) => {
    setSelectedItem(item);
    methods.reset({
      companyCode: userData?.companyCode,
      code: item.code,
      dieselID: item.dieselID,
      invoiceNumber: item.invoiceNumber,
      invoiceDate: item.invoiceDate,
      usageLitres: numberToPointNumber(item.usageLitres),
      amountInclGST: numberToPointNumber(item.amountInclGST),
      vehicleNumber: item.vehicleNumber,
      isActive: item.isActive,
      createUser: item.createUser,
      createDate: item.createDate,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const deleteItemHandler = (id) => {
    const payload = {
      companyCode: userData?.companyCode,
      code: id,
    };
    deleteDieselUsage(payload, {
      onSuccess: (data) => {
        if (data) {
          toast.success("Item Deleted Successfully.");

          setSelectedItem(null);
          setShow(false);
          // GetItems();
        } else {
          toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };

  const onSubmit = async (payload) => {
    if (selectedItem) {
      console.log(payload);
      const existingDataIndex = watch(
        "dieselUsageList"
      )?.findIndex((item) => item.dieselID === selectedItem.dieselID);
      const existingData = watch("dieselUsageList");

      existingData[existingDataIndex] = payload;

      setValue("dieselUsageList", [...existingData]);
    } else {
      const existingData = watch("dieselUsageList") || [];
      const newList =
        existingData.length > 0 ? [...existingData, payload] : [payload];
      setValue("dieselUsageList", newList);
    }

    // if (selectedItem) {
    //   updateDieselUsage(payload, {
    //     onSuccess: (data) => {
    //       if (data) {
    //         toast.success("Updated Successfully");
    //         setSelectedItem(null);
    setShow(false);
    //         GetItems();
    //       } else {
    //         toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
    //       }
    //     },
    //     onError: (error) => {
    //       toast.error(error.message || "Something went wrong.");
    //     },
    //   });
    // } else {
    //   insertDieselUsage(payload, {
    //     onSuccess: (data) => {
    //       if (data) {
    //         toast.success("Created Successfully.");
    //         setShow(false);
    //         GetItems();
    //       } else {
    //         toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
    //       }
    //     },
    //     onError: (error) => {
    //       toast.error(error.message || "Something went wrong.");
    //     },
    //   });
    // }
  };

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = useMemo(() => [
    {
      title: "Invoice Number",
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",
    },
    {
      title: "Invoice Date",
      dataIndex: "invoiceDate",
      key: "invoiceDate",
      render: (text) => format(new Date(text), "dd-MM-yyyy"),
    },
    { title: "Usage Litres", dataIndex: "usageLitres", key: "usageLitres" },
    {
      title: "AmountInclGST",
      dataIndex: "amountInclGST",
      key: "amountInclGST",
    },
    {
      title: "Vehicle Number",
      dataIndex: "vehicleNumber",
      key: "vehicleNumber",
    },
    {
      title: "Status",
      dataIndex: "isActive",
      render: (text, record) => (
        <>
          {text === true && (
            <div className="badges badge-linesuccess">Active</div>
          )}
          {text === false && (
            <div className="badges badge-linedanger">In Active</div>
          )}
        </>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>

          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="add-new-tooltip">Edit</Tooltip>}
          >
            <Link className="me-2 p-2" onClick={() => handleEditClick(record)}>
              <Edit className="feather-edit" />
            </Link>
          </OverlayTrigger>

          {/* <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="add-new-tooltip">Delete</Tooltip>}
          >
            <Link className="me-2 p-2" to="#">
              <Popconfirm
                title="Are you sure to Delete?"
                onConfirm={() => deleteItemHandler(record.code)}
              >
                <Trash2 className="feather-delete" />
              </Popconfirm>
            </Link>
          </OverlayTrigger> */}
        </div>
      ),
    },
  ]);

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    watch("dieselUsageList"),
    searchColumns
  );

  // if (isLoading || isAdding || isUpdating || isDeleting) {
  //   return <LoadingSpinner />;
  // }

  // if (isError) {
  //   return <Error404 error={error} />;
  // }

  return (
    <>
      <h4 className="header-title">Deisel</h4>

      <div className="card table-list-card border-0">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center">
            <TableTop
              onSearch={setSearchValue}
              toggleFilterVisibility={toggleFilterVisibility}
              isFilterVisible={isFilterVisible}
            />
            <button
              className="btn btn-primary"
              onClick={handleAddClick}
              type="button"
            >
              Add New
            </button>
          </div>
          <div className="table-responsive">
            <Table
              className="table  datanew"
              columns={columns}
              dataSource={filteredData}
            />
          </div>
        </div>
      </div>

      <FormProvider {...methods}>
        <DieselUsageModal
          mode={selectedItem ? "E" : "I"}
          onSubmit={onSubmit}
          show={show}
          handleClose={handleClose}
        />
      </FormProvider>
    </>
  );
};

export default DieselUsage;
